import { AmazonBillingInfo } from "../../../model";
import apiService from "../../ApiService";

export const amazonUpdateInfo = (info: AmazonBillingInfo) => {
  return apiService.put<void>({
    crm: true,
    path: `public/account/amazon`,
    requiresAuthPolicy: "user",
    body: {
      amazonAccount: {
        ...info.userData,
        receipts: info.receipts,
      },
    },
  });
};
